import React from 'react';
import Typography from '../Text/Typography';
import './Checkbox.css';

interface CheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string | React.ReactNode;
  labelVariant?: 'body' | 'body-small' | 'body-small-bold';
  id?: string;
  disabled?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

const Checkbox: React.FC<CheckboxProps> = ({ 
  checked, 
  onChange, 
  label, 
  labelVariant = 'body',
  id, 
  disabled = false,
  className,
  style 
}) => {
  const containerClass = `checkbox-container ${disabled ? 'disabled' : ''} ${className || ''}`.trim();
  const checkboxClass = `checkbox-custom${checked ? ' checked' : ''}${disabled ? ' disabled' : ''}`;

  return (
    <label className={containerClass} htmlFor={id} style={style}>
      <input
        id={id}
        type="checkbox"
        checked={checked}
        onChange={e => onChange(e.target.checked)}
        className="checkbox-input"
        disabled={disabled}
      />
      <span className={checkboxClass}></span>
      {label && (
        <Typography variant={labelVariant} className="checkbox-label">
          {label}
        </Typography>
      )}
    </label>
  );
};

export default Checkbox; 